export default __webpack_public_path__ + "static/media/waterImg.07dc2853.jpg";